import RecomendaCopacabana from './RecomendaCopacabana.jpg';
import RecomendaBonita from './RecomendaBonita.jpg';
import RecomendaCaboFrio from './RecomendaCaboFrio.jpg';
import RecomendaMorroSP from './RecomendaMorroSP.jpg';
import RecomendaOuroPreto from './RecomendaOuroPreto.jpg';
import RecomendaSalvador from './RecomendaSalvador.jpg';
import RecomendaSaoluis from './RecomendaSaoluis.jpg';
import RecomendaGramado from './RecomendaGramado.jpg';
import BentoGoncalves from './BentoGoncalves.jpg';
import RecomendaFozIguacu from './RecomendaFozIguacu.jpg';
import RecomendaPetropolis from './RecomendaPetropolis.jpg';
import RecomendaCamposdoJordao from './RecomendaCamposdoJordao.jpg';
import RecomendaSP from './RecomendaSP.jpg';
import RecomendaPortodegalinhas from './RecomendaPortodegalinhas.jpg';
import RecomendaBH from './RecomendaBH.jpg';
import RecomendaCUritiba from './RecomendaCUritiba.jpg';
import RecomendaFortaleza from './RecomendaFortaleza.jpg';
import RecomendaGoiania from './RecomendaGoiania.jpg';
import RecomendaIlheus from './RecomendaIlheus.jpg';
import RecomendaUberlandia from './RecomendaUberlandia.jpg';
import RecomendaVitoria from './RecomendaVitoria.jpg';
import RecomendaFlorianopolis from './RecomendaFlorianopolis.jpg';
import RecomendaCaldasNovas from './RecomendaCaldasNovas.jpg';
import RecomendaRecife from './RecomendaRecife.jpg';
import pacoteJPAREC from './pacoteJPAREC.jpg';
import RecomendaParaty2 from './RecomendaParaty2.jpg';
import RecomendaParaty from './RecomendaParaty.jpg';
import RecomendaDelRei from './RecomendaDelRei.jpg';
import RecomendaNatalMTG from './RecomendaNatalMTG.jpg';
import RecomendaRioDeJaneiro from './RecomendaRioDeJaneiro.jpeg';
import RecomendaRioDeJaneiro2 from './RecomendaRioDeJaneiro2.jpg';
import RecomendaMaceio from './RecomendaMaceio.jpg';
import seloLiveVoala from './seloLiveVoala.png';
import RecomendaCarnaval from './RecomendaCarnaval.jpg';
import recomendaPascoa from './RecomendaPascoa.jpg';
import recomendaTiradentes from './RecomendaTiradentes.jpg';
import RecomendaDiaTrabalhador from './RecomendaDiaTrabalhador.jpg';
import RecomendaCorpusChristi from './RecomendaCorpusChristi.jpg';
import RecomendaIndependenciaBrasil from './RecomendaIndependenciaBrasil.jpg';
import RecomendaNossaSenhora from './RecomendaNossaSenhora.jpg';
import RecomendaFinados from './RecomendaFinados.jpg';
import RecomendaProclamaçãoRepublica from './RecomendaProclamaçãoRepublica.jpg';
import RecomendaNatal from './RecomendaNatal.jpg';
import RecomendaAnoNovo from './RecomendaAnoNovo.jpg';
import RecomendaJeri from './RecomendaJeri.jpg';
import dicasVoala from './dicas-voala.jpg';
import RecomendaCamacari from './camacari-bh.jpg';
import BannerRecomendaCaldasNovas from './bannerRecomendaCaldasNovas.jpg';
import BlogCaldasNovas1 from './BlogCaldasNovas1.jpg';
import BlogCaldasNovas2 from './BlogCaldasNovas2.jpg';
import BlogCaldasNovas3 from './BlogCaldasNovas3.jpg';
import CardCaldasNovas1 from './CardCaldasNovas1.jpg';
import CardCaldasNovas2 from './CardCaldasNovas2.jpg';
import CardCaldasNovas3 from './CardCaldasNovas3.jpg';

import Economico from './RecomendaEconomico.png';
import Compacto from './RecomendaCompacto.png';
import Intermediario from './RecomendaIntermediario.png';
import Mini from './RecomendaMini.png';
import IntermediarioElite from './RecomendaIntermediarioElite.png';
import CompletoElite from './RecomendaCompletoElite.jpg';
import Premium from './RecomendaPremium.png';
import CompletoFullSize from './CompletoFullSize.png';
import Luxo from './Luxo.png';
import MiniElite from './MiniElite.jpg';
import StandartPadrao from './StandartPadrao.png';

import April from './April.png';
import { ALL_TIPS } from './dicas-voala-imagens/allTips';
import { ALL_TRAVEL_TYPES } from './type-travel/allTypes';

export const ALL_RECOMENDA = {
  RecomendaCarnaval,
  recomendaPascoa,
  recomendaTiradentes,
  RecomendaDiaTrabalhador,
  RecomendaCorpusChristi,
  RecomendaIndependenciaBrasil,
  RecomendaNossaSenhora,
  RecomendaFinados,
  RecomendaProclamaçãoRepublica,
  RecomendaNatal,
  RecomendaAnoNovo,
  RecomendaBonita,
  RecomendaCaboFrio,
  RecomendaMorroSP,
  RecomendaOuroPreto,
  RecomendaSalvador,
  RecomendaSaoluis,
  RecomendaNatalMTG,
  RecomendaGramado,
  RecomendaCaldasNovas,
  RecomendaFozIguacu,
  RecomendaPetropolis,
  RecomendaCamposdoJordao,
  RecomendaPortodegalinhas,
  RecomendaBH,
  RecomendaCUritiba,
  RecomendaFortaleza,
  RecomendaGoiania,
  RecomendaIlheus,
  RecomendaUberlandia,
  RecomendaMaceio,
  RecomendaVitoria,
  RecomendaSP,
  RecomendaFlorianopolis,
  RecomendaCamacari,
  RecomendaRecife,
  RecomendaCopacabana,
  pacoteJPAREC,
  seloLiveVoala,
  dicasVoala,
  RecomendaParaty,
  RecomendaParaty2,
  RecomendaDelRei,
  RecomendaRioDeJaneiro,
  RecomendaRioDeJaneiro2,
  RecomendaJeri,
  BentoGoncalves,
  BannerRecomendaCaldasNovas,
  blogCaldasNovas: {
    BlogCaldasNovas1,
    BlogCaldasNovas2,
    BlogCaldasNovas3,
  },
  cardCaldasNovas: {
    CardCaldasNovas1,
    CardCaldasNovas2,
    CardCaldasNovas3,
  },
  Seguro: {
    April,
  },
  Carro: {
    Economico,
    Compacto,
    Intermediario,
    Mini,
    IntermediarioElite,
    CompletoElite,
    Premium,
    CompletoFullSize,
    Luxo,
    MiniElite,
    StandartPadrao,
  },
  dicasVoalaImagens: ALL_TIPS,
  tipoViajante: ALL_TRAVEL_TYPES,
};
